import React, { useState } from "react";
import { Table, Typography, Button } from "antd";
import { PhoneOutlined } from "@ant-design/icons";
import moment from "moment";
import { getNotificationDialPhone } from "../../../../utils/notificationCloudCall";

const { Text } = Typography;

function NotificationsTable({
  pagination,
  dataSource,
  spinner,
  onMarkRead,
  onCall,
}) {
  const [callingId, setCallingId] = useState(null);

  const handleCall = async (record) => {
    if (!onCall || callingId) return;
    setCallingId(record.id);
    try {
      await onCall(record);
    } finally {
      setCallingId(null);
    }
  };

  const columns = [
    {
      title: "Title",
      dataIndex: "title",
      key: "title",
      render: (text, record) => (
        <span>
          {!record.isRead && (
            <span
              style={{
                display: "inline-block",
                width: 8,
                height: 8,
                borderRadius: "50%",
                background: "#52c41a",
                marginRight: 8,
              }}
            />
          )}
          <strong>{text}</strong>
        </span>
      ),
    },
    {
      title: "Message",
      dataIndex: "body",
      key: "body",
      render: (text) => <span>{text || "-"}</span>,
    },
    {
      title: "Type",
      dataIndex: "purpose",
      key: "purpose",
      render: (text) => (
        <span>
          {text === "TELECMI_MISSED_CALL" ? "Missed Call" : text || "-"}
        </span>
      ),
    },
    {
      title: "Status",
      dataIndex: "isRead",
      key: "isRead",
      align: "center",
      render: (isRead) => (
        <Text type={isRead ? "secondary" : undefined} strong={!isRead}>
          {isRead ? "Read" : "Unread"}
        </Text>
      ),
    },
    {
      title: "Created On",
      dataIndex: "createdAt",
      key: "createdAt",
      align: "center",
      render: (record) => (
        <span>
          {record ? moment(new Date(record)).format("DD/MM/YYYY HH:mm") : "-"}
        </span>
      ),
    },
    {
      title: "Action",
      key: "action",
      align: "center",
      render: (record) => (
        <span style={{ display: "inline-flex", gap: 12, alignItems: "center" }}>
          {getNotificationDialPhone(record) ? (
            <Button
              type="link"
              size="small"
              icon={<PhoneOutlined />}
              loading={callingId === record.id}
              onClick={(e) => {
                e.stopPropagation();
                handleCall(record);
              }}
            >
              Call
            </Button>
          ) : null}
          {record.isRead ? (
            <Text strong disabled>
              —
            </Text>
          ) : (
            <span
              className="linkylink"
              onClick={(e) => {
                e.stopPropagation();
                onMarkRead && onMarkRead(record.id);
              }}
            >
              Read
            </span>
          )}
        </span>
      ),
    },
  ];

  return (
    <Table
      rowKey={(row) => row.id}
      pagination={pagination}
      columns={columns}
      dataSource={dataSource}
      loading={spinner}
      rowClassName={(record) => (record.isRead ? "" : "notification-row-unread")}
    />
  );
}

export default NotificationsTable;
